/** * 分页组件 */
<template>
	<div class="lcsj-pagination" role="navigation" aria-label="表格分页">
	<div v-if="$slots.summary" class="lcsj-pagination__summary"><slot name="summary"></slot></div>
	<el-pagination v-if="showPager" ref="pager" class="page-box" background :current-page="pageparm.currentPage"
		:page-sizes="[5, 10, 15, 20, 50, 100, 200, 500, 1000]" :page-size="pageparm.pageSize"
		:layout="compact ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'" :pager-count="compact ? 5 : 7" :total="childMsg.total" @size-change="handleSizeChange"
		@current-change="handleCurrentChange"></el-pagination>
	</div>
</template>
<script>
export default {
	name: "Pagination",
	props: {
		childMsg: { type: Object, required: true },
		showPager: { type: Boolean, default: true }
	},
	data() {
		return {
			compact: false,
			pageparm: {
				currentPage: this.childMsg.currentPage || this.childMsg.pageIndex,
				pageSize: this.childMsg.pageSize
			}
		};
	},
	mounted() {
		if (typeof ResizeObserver !== 'undefined') {
			this.resizeObserver = new ResizeObserver(entries => {
				const summary = this.$el.querySelector(".lcsj-pagination__summary");
				this.compact = entries[0].contentRect.width - (summary ? summary.offsetWidth + 16 : 0) < 760;
			});
			this.resizeObserver.observe(this.$el);
		}
	},
	beforeDestroy() {
		if (this.resizeObserver) this.resizeObserver.disconnect();
	},
	watch: {
		childMsg: {
			handler(newVal) {
				if (newVal) {
					this.pageparm.currentPage = newVal.currentPage || newVal.pageIndex;
					this.pageparm.pageSize = newVal.pageSize;
				}
			},
			deep: true
		}
	},
	methods: {
		handleSizeChange(val) {
			/**
			 * 子传父
			 * 参数1 父元素方法
			 * 参数2 数据
			 */
			this.pageparm.pageSize = val;
			const payload = {
				currentPage: this.pageparm.currentPage || this.pageparm.pageIndex,
				pageSize: this.pageparm.pageSize
			};
			// Vue2 事件名区分大小写：同时派发 kebab 与 camel，兼容所有父级监听写法
			this.$emit("call-father", payload);
			this.$emit("callFather", payload);
		},
		handleCurrentChange(val) {
			/**
			 * 子传父
			 * 参数1 父元素方法
			 * 参数2 数据
			 */
			this.pageparm.currentPage = val;
			this.pageparm.pageIndex = val;
			const payload = {
				currentPage: val,
				pageSize: this.pageparm.pageSize
			};
			this.$emit("call-father", payload);
			this.$emit("callFather", payload);
		}
	}
};
</script>

<style>
.lcsj-pagination {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px 16px;
	width: 100%;
	min-width: 0;
	box-sizing: border-box;
	border: 1px solid var(--app-table-border);
	border-top: 0;
	border-radius: 0 0 var(--app-radius-md) var(--app-radius-md);
	background: var(--app-surface);
	padding: 12px 16px;
}
.lcsj-pagination__summary {
	flex: 1 1 280px;
	min-width: 0;
}
.lcsj-pagination .page-box {
	flex: 0 1 auto;
	min-width: 0;
	max-width: 100%;
	margin-left: auto;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 0;
	justify-content: flex-end;
	margin-top: 0;
	padding: 0;
	background: transparent;
}
.lcsj-pagination .el-pagination__total {
	margin-left: 0;
	margin-right: 12px;
	white-space: nowrap;
}
.lcsj-pagination .el-pagination__jump {
	margin-left: 12px;
}
.lcsj-pagination .el-pager li,
.lcsj-pagination .btn-prev,
.lcsj-pagination .btn-next {
	border-radius: var(--app-radius-sm);
	min-width: 30px;
	height: 30px;
	line-height: 30px;
}
.lcsj-table__pager { flex: 1; min-width: 0; }
.lcsj-table__ft .lcsj-pagination {
	border: 0;
	padding: 0;
}
@media (max-width: 600px) {
	.lcsj-pagination { padding: 10px; flex-wrap: wrap; }
	.lcsj-pagination__summary { flex-basis: 100%; }
	.lcsj-pagination .page-box { justify-content: flex-end; }
}
</style>
